module.exports = __webpack_public_path__ + "img/Feature.5ba32587.jpg";